module.exports = __webpack_public_path__ + "img/login-ems.1e39c742.svg";